import network from '@/utils/network'
import store from '@/store'

/**
 * Récupère la liste des checkpoints d'une agence
 * @returns {Promise<>}
 */
export const fetchAgencyCheckpoints = async () => {
  const slugAgency = store.getters['user/agencySlug']
  const r = await network.get(`/agency/${slugAgency}/checkpoints`)
  return r.data
}

/**
 * Soumet un checkpoint à l'api
 * @param client
 * @param site
 * @param rest
 * @deprecated
 * @returns {Promise<{}>}
 */
export const postCheckpoint = async ({ client, site, reference, ...checkpoint }) => {
  const slugAgency = store.getters['user/agencySlug']
  const r = reference
    ? await network.put(
      `/agency/${slugAgency}/customer/${client}/site/${site}/checkpoint/${reference}`,
      {
        checkpoint: JSON.stringify(checkpoint)
      }
    )
    : await network.post(
      `/agency/${slugAgency}/customer/${client}/site/${site}/checkpoint`,
      {
        checkpoint: JSON.stringify(checkpoint)
      })
  return r.data.checkpoint
}

/**
 * Retire un checkpoint dans une ronde
 * @param client
 * @param site
 * @returns {Promise<>}
 */
export const deleteCheckpoint = async ({ customer, site, id }) => {
  const slugAgency = store.getters['user/agencySlug']
  const r = await network.delete(`/agency/${slugAgency}/customer/${customer.slug}/site/${site.slug}/checkpoint/${id}`)
  return r.data
}
